import React from 'react';
import ButtonListComponent from './Components/ButtonListComponent.jsx';

/**
 * Class to display the button message template.
 */
export default class ButtonMessage extends ButtonListComponent {
    /**
     * Returns the matching masked user response when this was a previous message in
     * the chat history. If no match, then return the value from history.
     */
    static getMaskedHistory(payload, currentValue) {
        for (const button of payload.buttons) {
            if (currentValue === button.payload) {
                return button.title;
            }
        }

        return currentValue;
    }

    render() {
        return(
            <div className={this.generateSenderClassName('buttons')}>
                {this.generateSenderMessage()}
                <div className='buttons__text message-text' dangerouslySetInnerHTML={this.evaluateMarkdown(this.props.payload.text)} />
                {this.generateButtonList(this.props.payload.buttons)}
            </div>
        );
    }
}